import * as styles from './styles';

import { MultiSelectVehicleAssociationType } from '@cobliteam/common-types';

import {
  type CheckboxOption,
  FilterMultipleDropdown,
  LinkIcon,
} from '@cobliteam/base-components';

interface MultiSelectVehicleAssociationTypeProps {
  size?: 'condensed' | 'regular';
  isOpen: boolean;
  selectedAssociationStatus?: Set<MultiSelectVehicleAssociationType>;
  options?: MultiSelectVehicleAssociationType[];
  onDropdownClick: () => void;
  onCancel: () => void;
  onChange: (
    selectedAssociations: Set<MultiSelectVehicleAssociationType>
  ) => void;
}

const MultiSelectVehicleAssociation = ({
  size = 'regular',
  isOpen,
  selectedAssociationStatus,
  options,
  onDropdownClick,
  onCancel,
  onChange,
}: MultiSelectVehicleAssociationTypeProps) => {
  const toFilterOption = (
    associationType: MultiSelectVehicleAssociationType
  ) => ({
    key: associationType,
    label: associationType,
  });

  const filterOptions = options
    ? options.map(toFilterOption)
    : Object.values(MultiSelectVehicleAssociationType).map(toFilterOption);

  const handleFilterApply = (selectedAssociations: CheckboxOption[]) => {
    const newAssociations: MultiSelectVehicleAssociationType[] =
      selectedAssociations.map(
        (type) => type.key as MultiSelectVehicleAssociationType
      );

    onChange(new Set(newAssociations));
  };

  return (
    <FilterMultipleDropdown
      size={size}
      overlayClassName={styles.filterOverlay}
      buttonIcon={<LinkIcon />}
      options={filterOptions}
      selectedOptionKeys={new Set(selectedAssociationStatus)}
      buttonTitle='Filtrar associação'
      isOpen={isOpen}
      onDropdownClick={onDropdownClick}
      onClear={() => {}}
      onCancel={onCancel}
      onApply={handleFilterApply}
      withActionButtons
    />
  );
};

export default MultiSelectVehicleAssociation;
